import React from 'react';
import { Box, Stack } from '@mui/system';
import Navigation from '../components/ui/navigation';
import { useAuth } from '../contexts/authContext';
import MainNavigation from '../components/ui/navigation/mainNavigation';

const PrivateLayout = ({ children, ...props }) => {
  return <MainNavigation>{children}</MainNavigation>;
};

export default PrivateLayout;
